const advId = document.querySelector('#adv-id')
const quote = document.querySelector('#quote')
const dado = document.querySelector('#dado')

function rollDice() {
  fetch('https://api.adviceslip.com/advice')
  .then(r => r.json())
  .then(advice => {
    advId.innerText = advice.slip.id
    quote.innerText = advice.slip.advice
  })
}

dado.addEventListener('click', rollDice)
